import React from 'react'

const EmployeeManagementSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2244_11431)" />
    <path
      d="M28.9443 49.4998C25.422 49.4998 21.9538 49.4998 18.4314 49.4998C16.7515 49.4998 16.1554 48.7412 16.4263 47.1697C17.456 41.3171 22.4957 36.9277 28.3482 36.7109C34.5259 36.4941 39.9992 40.5584 41.4081 46.3568C42.0042 48.7412 41.4081 49.4998 38.9696 49.4998C35.6098 49.4998 32.3041 49.4998 28.9443 49.4998Z"
      fill="white"
    />
    <path
      d="M28.9985 20.5083C32.7919 20.5083 35.8265 23.4888 35.8265 27.2279C35.8265 30.8587 32.6293 34.0017 28.9443 34.0017C25.2594 34.0017 22.1705 30.8587 22.1705 27.1737C22.1705 23.4346 25.151 20.5083 28.9985 20.5083Z"
      fill="white"
    />
    <path
      opacity="0.6"
      d="M40.8662 20.5081C43.7925 20.5081 46.1768 22.188 47.2607 24.8434C48.3445 27.6071 47.64 30.5875 45.4724 32.4842C43.5215 34.2183 40.3785 34.6518 38.1025 33.5138C37.2896 33.0803 36.7477 32.8635 37.669 31.8339C39.9449 29.287 39.9449 25.7104 37.7231 23.1093C36.8019 22.0255 37.127 21.6461 38.1567 21.1584C39.0779 20.6707 40.0533 20.4539 40.8662 20.5081Z"
      fill="white"
    />
    <path
      opacity="0.6"
      d="M44.6053 49.2288C45.4723 48.0908 45.1472 47.0612 44.8762 45.9774C43.9008 42.5634 41.8416 39.9622 38.7527 38.174C38.3192 37.903 37.7231 37.8488 37.4521 37.3069C44.4427 34.9225 52.6255 40.0164 53.6009 47.2238C53.7635 48.416 53.3841 49.1746 52.0836 49.1746C49.5908 49.2288 47.2064 49.2288 44.6053 49.2288Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2244_11431"
        x1="35"
        y1="0"
        x2="35"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0B62B5" />
        <stop offset="1" stopColor="#003F7C" />
      </linearGradient>
    </defs>
  </svg>
)

export default EmployeeManagementSubcategory
